export enum MdEnableStatusEnum {
    DISABLE,
    ENABLE,
}

export enum PartnerTypeEnum {
    CUSTOMER = 'PARTNER-TYPE.CUS',
    SUPPLIER = 'PARTNER-TYPE.SUP',
}

export enum UserTypeEnum {
    EMPLOYEE = 'user-type.employee', // "内部员工"
    MICRO_BOSS = 'user-type.micro-boss', // "微老板"
    DRIVER = 'user-type.driver', //"司机"
    HEADMAN = 'user-type.headman', //"队长"
    BOSS = 'user-type.boss', // "老板"
    SUPPLIER = 'user-type.supplier', //"供应商"
    CUSTOMER = 'user-type.customer', //"客户"
}

export enum TradeTypeEnum {
    SALE = 'trade-type.sale', //销售,
    PURCHASE = 'trade-type.purchase', //采购
    SALE_RETURN = 'trade-type.sale-return', //销售退货
    PURCHASE_RETURN = 'trade-type.purchase-return', //采采购退货
    PURCHASE_PLAN = 'trade-type.purchase-plan', //采购计划
    SALE_ORDER = 'trade-type.sale-order', //销售订单
    APPOINTMENT = 'trade-type.appointment', //预约
    MAINTENANCE = 'trade-type.maintenance', //维修
    DISPATCH = 'trade-type.dispatch', //派工
    SETTLE = 'trade-type.settle', //结算
    RETURN_VISIT = 'trade-type.return-visit', //回访
    STOCKTAKING = 'trade-type.stocktaking', //盘库
    LOSS = 'trade-type.loss', //损失
    BILL_DISCOUNT = 'trade-type.bill-discount', //账单抹零
}

export enum ReviewStatusEnum {
    INIT,
    REVIEWING,
    REVIEWED,
    REJECTED = 9,
}

export enum AccountStatusEnum {
    INIT,
    DISABLED = 9,
}

export enum CreditFlagEnum {
    NON_CREDIT,
    CREDIT,
}

export enum AdjustStatusEnum {
    INIT,
    REVIEWING,
    ADJUSTED,
    REJECTED = 8,
    FAIL,
}

export enum RechargeStatusEnum {
    INIT,
    RECHARGED,
    FAIL = 9,
}

export enum TransferStatusEnum {
    INIT,
    RECHARGED,
    FAIL = 9,
}

export enum AccountLogTypeEnum {
    OPEN = 'OPEN',
    DISABLE = 'DISABLE',
    ENABLE = 'ENABLE',
    ADJUST = 'ADJUST',
    ADJUST_APPROVAL = 'ADJUST_APPROVAL',
    RECHARGE = 'RECHARGE',
    TRANSFER_IN = 'TRANSFER_IN',
    TRANSFER_OUT = 'TRANSFER_OUT',
    BALANCE = 'BALANCE',
    UPDATE = 'UPDATE',
}

export enum BillIoFlagEnum {
    IN = 1,
    OUT,
}

export enum BillPayTypeEnum {
    CASH = 1,
    CREDIT_ACCOUNT,
}

export enum BillStatusEnum {
    INIT,
    BOOKED,
    BALANCED,
}

export enum BillCashStatusEnum {
    INIT,
    CASHED,
    RECHARGED,
    BALANCED,
    FAIL = 9,
}

export enum BillCancelStatusEnum {
    INIT,
    REVIEWING,
    CANCELLED,
    FAIL,
}

export enum BillInvoiceStatusEnum {
    INIT,
    APPLYING,
    PARTIAL,
    INVOICED,
}

export enum BillBalanceStatusEnum {
    INIT,
    BALANCED,
    FAIL = 9,
}

export enum BillLogTypeEnum {
    INSERT = 'INSERT',
    APPROVAL = 'DISABLE',
    CREDIT_BOOK = 'CREDIT_BOOK',
    CASH_BOOK = 'CASH_BOOK',
    BALANCE = 'BALANCE',
    INVOICE = 'INVOICE',
    INVOICE_CANCEL = 'INVOICE',
    INVOICE_APPROVAL = 'INVOICE_APPROVAL',
    CANCEL = 'CANCEL',
    CANCEL_APPROVAL = 'CANCEL_APPROVAL',
}

export enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2,
}

//记录各种单价的上浮
export enum RATES {
    RATE = 1.02,
    OU_HAO = 1.04,
    YUN_HU = 1.04,
}


export enum calculateStatusEnum {
    'calculate.draft' = '草拟',
    'calculate.init' = '已开单',
    'calculate.finish' = '已完结',
    'calculate.transferred' = '已转接'
}


export enum userQuotationStatusEnum {
    'quotation.draft' = '草拟',
    'quotation.init' = '已开单',
    'quotation.finish' = '已完结',
    'calculate.transferred' = '已转接'
}

export enum breakRepairStatusEnum {

    'repair.init' = '已开单',

    'repair.transferred' = '已转接'
}

export enum sendWorkStatusEnum {

    'send.init' = '已开单',

    'send.sendwork' = '已派工'
}

//消息提醒次数
export enum messageInformPeriodEnum {
    INFORMPERIOD_ONE = 'informPeriod.one',//一次
    INFORMPERIOD_MORE = 'informPeriod.more'//多次
}

//消息提醒类型
export enum messageInformModeEnum {
    INFORMMODE_SMS = 'informMode.sms',//短信
    INFORMMODE_OFFICIALACCOUNT = 'informMode.officialAccount',//公众号
    INFORMMODE_INSTATION = 'informMode.instation'//站内
}

//消息状态
export enum messageStatusEnum {
    MESSAGE_INIT = 'message.init',//未读
    MESSAGE_READ = 'message.read',//已读
    MESSAGE_END = 'message.end'//完成
}

//工单状态
export enum orderStatusEnum {
    'pending_order' = '待派单',
    'pending_labor' = '已派单',
    'pending_departure' = '待出发',
    'already_departure' = '已出发',
    'in_maintenance' = '维修中',
    'pending_payment' = '待付款',
    'pending_system_review' = '待系统审核',
    'system_review_fail' = '系统审核失败',
    'tobe_confirmed' = '待确认',
    'completed' = '已完成',
    'cancelled' = '已取消',
    'organ_transferred' = '已转派机构',
}

//工单类型
export enum orderTypeEnum {
    '014001' = '收费',
    '014002' = '三包',
    '014003' = '三包/收费',
    '014006' = '云豪大包',
}

//维修类型
export const maintenanceTypeList = [
    { value: 'self_repair', label: '自修' },
    { value: 'external_repair', label: '外修' }
]
//成员类型
export const OperatorUserType = {
    '1': '内部员工',
    '2': '团队',
    '3': '客户'
}
//成员类型
export const vehiclePowerList = [
    { value: '新能源', label: '新能源' },
    { value: '燃油车', label: '燃油车' }
]
//三检车辆类型
export const vehicleTypeList = [
    { value: '钢瓶车', label: '钢瓶车' },
    { value: '液体车', label: '液体车' },
    { value: '直车', label: '直车' },
    { value: '买可保', label: '买可保' },
    { value: '吊机钢瓶车', label: '吊机钢瓶车' }
]
// 三检状态
export const threeInspectionStatus = {
    'allow.departure': '允许发车',
    'no.departure.allowed': '禁止发车',
    'there.are.hidden.dangers': '有隐患',
    'not.started': '未开始',
    'hang.in.the.air': '未完成',
    'there.ended': '已完成'
}
// 三检状态
export const assignStatus = {
    'unallocated': '待分配',
    'waiting.reply': '待回复',
    'to.be.confirmed': '待确认',
    'driver.to.be.confirmed': '待司机确认',
    'driver.confirmed': '已完成',
    'adopt': '通过'
}
export const assignStatusList = [
    { value: 'unallocated', label: '待分配' },
    { value: 'waiting.reply', label: '待回复' },
    { value: 'to.be.confirmed', label: '待确认' },
    { value: 'driver.to.be.confirmed', label: '待司机确认' },
    { value: 'driver.confirmed', label: '已完成' },
    { value: 'adopt', label: '通过' }
]
//(现场照片)
export const imgTeamLists = [
    {
        'id': 'bb1163320b98afc274ca8fa401c92ea1',
        'deleteFlag': 0,
        'createUser': 'tester',
        'createTime': '2020-12-24 11:02:43',
        'updateUser': 'f27d98228184490fb24f12b3e2e4f512',
        'updateTime': '2021-06-04 16:42:17',
        'imageGroup': 'team',
        'imageCode': 'vehicle_45°',
        'imageName': '整车45°',
        'imageDesc': '团队端上传必填',
        'required': 0,
        'componentSort': 2,
        'disableFlag': 0,
        'remark': null
    },
    {
        'id': '8cad370ca094c8bae8f63e09c0825cd0',
        'deleteFlag': 0,
        'createUser': 'tester',
        'createTime': '2020-12-24 11:03:27',
        'updateUser': 'f27d98228184490fb24f12b3e2e4f512',
        'updateTime': '2021-06-04 16:42:05',
        'imageGroup': 'team',
        'imageCode': 'repair_process',
        'imageName': '维修过程',
        'imageDesc': '团队端上传必填',
        'required': 0,
        'componentSort': 3,
        'disableFlag': 0,
        'remark': null
    },
    {
        'id': '2bda8dabd77fa9ebf62374499e1bb7b9',
        'deleteFlag': 0,
        'createUser': 'tester',
        'createTime': '2020-12-24 11:05:38',
        'updateUser': 'f27d98228184490fb24f12b3e2e4f512',
        'updateTime': '2021-06-04 16:41:58',
        'imageGroup': 'team',
        'imageCode': 'kilometers',
        'imageName': '公里数',
        'imageDesc': '团队端上传必填',
        'required': 0,
        'componentSort': 5,
        'disableFlag': 0,
        'remark': null
    },
    {
        'id': '07c9d4dc16183979c885706dde9ee05f',
        'deleteFlag': 0,
        'createUser': 'tester',
        'createTime': '2020-12-24 11:03:55',
        'updateUser': 'f27d98228184490fb24f12b3e2e4f512',
        'updateTime': '2021-06-04 16:41:52',
        'imageGroup': 'team',
        'imageCode': 'maintenance_site',
        'imageName': '维修现场',
        'imageDesc': '团队端上传必填',
        'required': 0,
        'componentSort': 2,
        'disableFlag': 0,
        'remark': null
    },
    {
        'id': '01f694040ed57e2baf5b927e5ac578d6',
        'deleteFlag': 0,
        'createUser': 'tester',
        'createTime': '2020-12-24 11:06:10',
        'updateUser': 'f27d98228184490fb24f12b3e2e4f512',
        'updateTime': '2021-03-15 17:56:33',
        'imageGroup': 'team',
        'imageCode': 'faulty_parts_num',
        'imageName': '故障件编号',
        'imageDesc': '团队端上传必填',
        'required': 0,
        'componentSort': 7,
        'disableFlag': 0,
        'remark': null
    },
    {
        'id': '3040f0c1cf791ea550ab64984874129d',
        'deleteFlag': 0,
        'createUser': 'tester',
        'createTime': '2020-12-24 11:06:42',
        'updateUser': 'f27d98228184490fb24f12b3e2e4f512',
        'updateTime': '2021-03-15 17:56:27',
        'imageGroup': 'team',
        'imageCode': 'new_part_number',
        'imageName': '新件编号',
        'imageDesc': '团队端上传必填',
        'required': 0,
        'componentSort': 8,
        'disableFlag': 0,
        'remark': null
    },
    {
        'id': 'cc04df942e5e2bfa4b37ffe70ad78cd3',
        'deleteFlag': 0,
        'createUser': 'tester',
        'createTime': '2020-12-24 11:05:17',
        'updateUser': 'f27d98228184490fb24f12b3e2e4f512',
        'updateTime': '2021-03-15 17:56:09',
        'imageGroup': 'team',
        'imageCode': 'three_guarantees_service_order_number',
        'imageName': '三包服务单号',
        'imageDesc': '团队端上传必填',
        'required': 0,
        'componentSort': 4,
        'disableFlag': 0,
        'remark': null
    },
    {
        'id': '52e1bdd75bc3f2b5ed26378254b0d251',
        'deleteFlag': 0,
        'createUser': 'f27d98228184490fb24f12b3e2e4f512',
        'createTime': '2020-12-24 10:58:58',
        'updateUser': 'f27d98228184490fb24f12b3e2e4f512',
        'updateTime': '2021-03-15 17:55:39',
        'imageGroup': 'team',
        'imageCode': 'driving_license',
        'imageName': '行驶证',
        'imageDesc': '团队端上传必填',
        'required': 0,
        'componentSort': 1,
        'disableFlag': 0,
        'remark': null
    },
    {
        'id': '7109a9760e81cd9e0cf607852b34e97e',
        'deleteFlag': 0,
        'createUser': 'tester',
        'createTime': '2020-12-24 11:09:00',
        'updateUser': 'f27d98228184490fb24f12b3e2e4f512',
        'updateTime': '2020-12-30 11:35:15',
        'imageGroup': 'team',
        'imageCode': 'other_assembly_nameplate',
        'imageName': '其它总成铭牌',
        'imageDesc': '团队端上传必填',
        'required': 0,
        'componentSort': 2,
        'disableFlag': 0,
        'remark': null
    },
    {
        'id': 'a7d18bd7ea96e9fc718fc0cea85e14a1',
        'deleteFlag': 0,
        'createUser': 'tester',
        'createTime': '2020-12-24 11:08:48',
        'updateUser': 'f27d98228184490fb24f12b3e2e4f512',
        'updateTime': '2020-12-30 11:35:05',
        'imageGroup': 'team',
        'imageCode': 'bridge_nameplate',
        'imageName': '桥铭牌',
        'imageDesc': '团队端上传必填',
        'required': 0,
        'componentSort': 2,
        'disableFlag': 0,
        'remark': null
    },
    {
        'id': 'ce15dcd70d021fb87164d2ac93de0476',
        'deleteFlag': 0,
        'createUser': 'tester',
        'createTime': '2020-12-24 11:08:37',
        'updateUser': 'f27d98228184490fb24f12b3e2e4f512',
        'updateTime': '2020-12-30 11:34:54',
        'imageGroup': 'team',
        'imageCode': 'gearbox_nameplate',
        'imageName': '变速箱铭牌',
        'imageDesc': '团队端上传必填',
        'required': 0,
        'componentSort': 2,
        'disableFlag': 0,
        'remark': null
    },
    {
        'id': 'aa17db98047f571ad4827cff913f1cd9',
        'deleteFlag': 0,
        'createUser': 'tester',
        'createTime': '2020-12-24 11:08:26',
        'updateUser': 'f27d98228184490fb24f12b3e2e4f512',
        'updateTime': '2020-12-30 11:34:39',
        'imageGroup': 'team',
        'imageCode': 'engine_nameplate',
        'imageName': '发动机铭牌',
        'imageDesc': '团队端上传必填',
        'required': 0,
        'componentSort': 2,
        'disableFlag': 0,
        'remark': null
    },
    {
        'id': '5061d738fdb422f448ed44c86f66e95a',
        'deleteFlag': 0,
        'createUser': 'f27d98228184490fb24f12b3e2e4f512',
        'createTime': '2020-12-23 11:39:33',
        'updateUser': 'f27d98228184490fb24f12b3e2e4f512',
        'updateTime': '2020-12-24 10:52:49',
        'imageGroup': 'team',
        'imageCode': 'repair_completed_img',
        'imageName': '团队维修图片',
        'imageDesc': '团队端上传维修过程图片。会被慢慢弃用',
        'required': 0,
        'componentSort': 53,
        'disableFlag': 0,
        'remark': ''
    },
    {
        'id': 'a7b4a6b759f03a8e920be4967796b828',
        'deleteFlag': 0,
        'createUser': 'f27d98228184490fb24f12b3e2e4f512',
        'createTime': '2020-12-24 10:39:41',
        'updateUser': null,
        'updateTime': '2020-12-24 10:39:40',
        'imageGroup': 'team',
        'imageCode': 'repair_completed_img',
        'imageName': '团队维修图片',
        'imageDesc': '团队端上传维修过程图片。会被慢慢弃用',
        'required': 0,
        'componentSort': null,
        'disableFlag': 0,
        'remark': null
    }
]

//(故障照片)
export const imgCustomerLists = [
    {
        'id': 'cc3a19c42254cf1a7cb242a40d6b1a1f',
        'deleteFlag': 0,
        'createUser': 'f27d98228184490fb24f12b3e2e4f512',
        'createTime': '2020-12-24 10:38:18',
        'updateUser': null,
        'updateTime': '2020-12-24 10:38:18',
        'imageGroup': 'customer',
        'imageCode': 'repair_img',
        'imageName': '客户报修图片',
        'imageDesc': '客户报修',
        'required': 0,
        'componentSort': 0,
        'disableFlag': 0,
        'remark': null
    }
]
